class FlexHttpError extends Error {
  constructor(code, message, status, title, trace) {
    super(message);
    this.code = code;
    this.message = message;
    this.status = status;
    this.title = title;
    this.trace = trace;
    this.name = "FlexHttpError";
  }
}

export { FlexHttpError };
//# sourceMappingURL=flexHttpError.mjs.map
